var _linearGradient, _radialGradient, _linearGradient2, _linearGradient3, _radialGradient2, _radialGradient3, _radialGradient4, _linearGradient4, _radialGradient5, _radialGradient6, _linearGradient5, _radialGradient7, _radialGradient8, _radialGradient9, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _path, _path2, _path3, _path4, _polygon, _polygon2, _path5, _polygon3, _polygon4, _path6, _path7, _path8, _path9, _path0, _polygon5, _path1, _path10, _path11, _path12, _polygon6, _polygon7, _polygon8, _polygon9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBmw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1015,
    viewBox: "-.68 -.847 1015 1015",
    width: 1015,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -74.1968,
    x2: 1001.2502,
    y1: -54.6484,
    y2: 984.5881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dff4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0984,
    stopColor: "#d6eaf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    stopColor: "#bfd0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4879,
    stopColor: "#98a5ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#646b6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2b2b"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: -6.3174,
    cy: 33.522,
    gradientUnits: "userSpaceOnUse",
    r: 720.1076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3064,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(-1 0 0 -1 930.9756 1169.3057)",
    gradientUnits: "userSpaceOnUse",
    x1: 54.041,
    x2: 738.989,
    y1: 304.8472,
    y2: 966.7329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dff4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0855,
    stopColor: "#d6eaf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2327,
    stopColor: "#bed0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4239,
    stopColor: "#96a4ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6516,
    stopColor: "#5f686d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9075,
    stopColor: "#1a1d1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3102,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4505,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5567,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7238,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7944,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8593,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9199,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9746,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: -135.6465,
    cy: -39.812,
    gradientUnits: "userSpaceOnUse",
    r: 1730.3135,
    xlinkHref: "#d"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: -135.7231,
    cy: -39.8115,
    gradientUnits: "userSpaceOnUse",
    r: 1730.4609,
    xlinkHref: "#d"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: -135.8174,
    cy: -40.3198,
    gradientUnits: "userSpaceOnUse",
    r: 1731.7866,
    xlinkHref: "#d"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1045,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3074,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5884,
    stopColor: "#6c6c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9335,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 174.2534,
    cy: 200.0752,
    gradientUnits: "userSpaceOnUse",
    r: 466.7181,
    xlinkHref: "#h"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 301.9058,
    cy: 262.8477,
    gradientUnits: "userSpaceOnUse",
    r: 678.7418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3435,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4814,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5824,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6654,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7373,
    stopColor: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8602,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9494,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9566,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1957,
    stopColor: "#e0eff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2406,
    stopColor: "#b2d9ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2872,
    stopColor: "#8bc5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#6bb5da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3844,
    stopColor: "#52a9d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4359,
    stopColor: "#41a0cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#369bcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#39c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#3396c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6553,
    stopColor: "#328ebc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7045,
    stopColor: "#3180a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7536,
    stopColor: "#2f6d8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8027,
    stopColor: "#2d5468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8512,
    stopColor: "#2a373d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#292929"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 102.6182,
    cy: 5.5596,
    gradientUnits: "userSpaceOnUse",
    r: 1202.0598,
    xlinkHref: "#k"
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 102.6182,
    cy: 5.5513,
    gradientUnits: "userSpaceOnUse",
    r: 1202.0366,
    xlinkHref: "#k"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 180.6274,
    cy: 205.9541,
    gradientUnits: "userSpaceOnUse",
    r: 457.773,
    xlinkHref: "#h"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1086,
    stopColor: "#ebeff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2475,
    stopColor: "#dce0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4028,
    stopColor: "#c4c7cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5701,
    stopColor: "#a2a4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#76777c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#414243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2b2b"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 446.8354,
    x2: 893.2535,
    xlinkHref: "#o",
    y1: 91.6548,
    y2: 523.0419
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 84.4878,
    x2: 530.9141,
    xlinkHref: "#o",
    y1: 455.8701,
    y2: 887.2653
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 300.459,
    x2: 531.948,
    y1: 302.0415,
    y2: 525.7363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2d7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1337,
    stopColor: "#bacfe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3425,
    stopColor: "#a4bacd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6001,
    stopColor: "#8098ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    stopColor: "#4e697f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a566d"
  }))), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 184.5244,
    x2: 626.4575,
    y1: 356.8545,
    y2: 783.9076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0973,
    stopColor: "#e8ebf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2568,
    stopColor: "#d1d4dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4587,
    stopColor: "#abaeb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6951,
    stopColor: "#78797d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9578,
    stopColor: "#363637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2b2b"
  }))), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 510.2568,
    x2: 665.2748,
    y1: 515.2671,
    y2: 665.0656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9def0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    stopColor: "#d4daec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#c7cfe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4114,
    stopColor: "#b0bcd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    stopColor: "#90a1b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7246,
    stopColor: "#677f99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8849,
    stopColor: "#355674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9719,
    stopColor: "#173d5d"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 351.6777,
    x2: 793.1321,
    xlinkHref: "#o",
    y1: 194.7759,
    y2: 621.3665
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m506.86 0c-279.92 0-506.86 226.918-506.86 506.848 0 279.926 226.94 506.848 506.86 506.848 279.94 0 506.857-226.922 506.857-506.848.001-279.93-226.916-506.848-506.857-506.848zm0 988.352c-265.939 0-481.495-215.574-481.495-481.504 0-265.927 215.556-481.512 481.495-481.512 265.937 0 481.511 215.584 481.511 481.512 0 265.93-215.574 481.504-481.511 481.504z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m992.003 506.848c0 267.914-217.227 485.133-485.143 485.133-267.919 0-485.123-217.219-485.123-485.133 0-267.929 217.204-485.133 485.123-485.133 267.916 0 485.143 217.204 485.143 485.133z",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m988.371 506.848c0 265.93-215.574 481.504-481.511 481.504-265.939 0-481.495-215.574-481.495-481.504 0-265.927 215.556-481.512 481.495-481.512 265.937 0 481.511 215.585 481.511 481.512z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m829.676 506.848c0 178.28-144.53 322.803-322.815 322.803-178.289 0-322.819-144.522-322.819-322.803 0-178.289 144.53-322.816 322.819-322.816 178.285 0 322.815 144.528 322.815 322.816z",
    fill: "url(#c)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "519.79 175.308 553.324 86.431 553.324 175.308 578.792 175.308 578.792 48.021 540.518 48.021 505.704 139.157 506.035 139.157 471.223 48.021 432.947 48.021 432.947 175.308 458.416 175.308 458.416 86.431 491.949 175.308"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "869.313 232.384 825.798 295.831 894.146 262.216 912.684 284.447 805.115 338.459 783.379 312.144 825.077 249.275 824.83 248.965 755.473 278.651 733.489 252.513 806.021 156.469 824.563 178.712 779.146 239.871 849.433 208.522"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m281.427 208.068c-10.251-9.951-26.069-12.951-40.939-3.733 2.847-7.363 1.691-14.858.186-19.015-6.414-11.662-8.662-13.137-13.899-17.561-17.097-14.324-35.082-2.093-47.93 13.219l-62.116 74.028 97.651 81.925 65.5-78.047c14.971-17.838 17.282-35.523 1.547-50.816zm-126.321 35.7l37.311-44.464c4.33-5.146 14.106-4.94 20.375.341 6.908 5.795 6.928 14.002 2.289 19.54l-36.896 43.95zm102.934 7.393l-38.896 46.353-24.355-20.47 39.185-46.711c4.434-5.281 14.313-6.817 20.974-1.229 7.505 6.312 8.247 15.912 3.092 22.057z",
    fill: "#333"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#e)",
    points: "520.06 170.39 553.592 81.515 553.592 170.39 579.063 170.39 579.063 43.103 540.784 43.103 505.973 134.236 506.303 134.236 471.491 43.103 433.212 43.103 433.212 170.39 458.683 170.39 458.683 81.515 492.218 170.39"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#f)",
    points: "869.563 223.844 826.067 287.293 894.413 253.667 912.934 275.909 805.38 329.921 783.645 303.596 825.345 240.735 825.1 240.416 755.72 270.114 733.759 243.963 806.291 147.93 824.83 170.164 779.419 231.322 849.68 199.985"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m276.868 205.563c-10.23-9.951-26.069-12.953-40.916-3.743 2.824-7.364 1.67-14.86.166-18.996-6.415-11.682-8.642-13.137-13.923-17.57-17.096-14.333-35.059-2.095-47.887 13.231l-62.139 74.016 97.653 81.926 65.499-78.059c14.953-17.839 17.282-35.512 1.547-50.805zm-126.317 35.698l37.307-44.453c4.312-5.155 14.086-4.949 20.376.319 6.909 5.806 6.93 14.023 2.268 19.54l-36.873 43.959zm102.952 7.393l-38.896 46.352-24.398-20.47 39.207-46.721c4.433-5.269 14.291-6.806 20.953-1.216 7.547 6.32 8.29 15.9 3.134 22.055z",
    fill: "url(#g)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m194.788 506.852c0-172.358 139.724-312.082 312.073-312.082 172.367 0 312.072 139.724 312.072 312.082 0 172.351-139.705 312.071-312.072 312.071-172.35 0-312.073-139.72-312.073-312.071z",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m203.759 506.852c0-167.399 135.702-303.112 303.102-303.112s303.12 135.712 303.12 303.112c0 167.401-135.721 303.113-303.12 303.113s-303.102-135.712-303.102-303.113z",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m203.284 506.852h303.576v-303.575c-167.669 0-303.576 135.908-303.576 303.575z",
    fill: "url(#l)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m506.86 506.852v303.579c167.667 0 303.576-135.933 303.576-303.579z",
    fill: "url(#m)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#n)",
    points: "812.95 501.458 512.242 501.458 512.242 200.75 501.476 200.75 501.476 501.458 200.768 501.458 200.768 512.225 501.476 512.225 501.476 812.942 512.242 812.942 512.242 512.225 812.95 512.225"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m512.242 209.267c160.141 2.848 289.366 132.062 292.232 292.191h5.36c-2.863-163.099-134.482-294.736-297.593-297.583v5.392z",
    fill: "url(#p)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m208.729 501.418c2.845-160.347 132.256-289.747 292.604-292.604v-5.383c-163.336 2.856-295.12 134.669-297.987 297.986h5.383z",
    fill: "#c2d7e8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m501.476 804.433c-160.139-2.844-289.364-132.069-292.211-292.208h-5.381c2.866 163.108 134.484 294.75 297.593 297.594v-5.386z",
    fill: "url(#q)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m804.475 512.225c-2.866 160.139-132.092 289.364-292.232 292.208v5.386c163.11-2.844 294.747-134.485 297.593-297.594z",
    fill: "#12404f"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#r)",
    points: "495.724 203.432 495.724 495.551 203.614 495.551 203.614 501.315 495.724 501.315 501.476 501.315 501.476 495.551 501.476 203.432"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#s)",
    points: "495.229 806.995 495.229 518.391 206.029 518.391 206.029 512.7 495.229 512.7 500.92 512.7 500.92 518.391 500.92 806.995"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#t)",
    points: "518.409 806.995 518.409 518.391 807.011 518.391 807.011 512.7 518.409 512.7 512.737 512.7 512.737 518.391 512.737 806.995"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#u)",
    points: "518.409 206.011 518.409 494.613 807.011 494.613 807.011 500.295 518.409 500.295 512.737 500.295 512.737 494.613 512.737 206.011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmw);
export default __webpack_public_path__ + "static/media/bmw.04097b65d401bb31012dbe974057d267.svg";
export { ForwardRef as ReactComponent };